const SITE_ANCHOR = 'int-site';
const PRODUCT_LIST_ANCHOR = 'productList';
const LEFT_COLUMN_WIDTH = 768;

const PAGE_TYPES = {
  MODULE: 'module',
  SUBJECT: 'subject',
  HOME_PAGE: 'home_page',
  LANDING_PAGE: 'landing_page',
  CONTACT_US: 'contact_us',
  MODULE_ACCESSIBILITY_STATEMENT: 'module_accessibility',
  QUALIFICATION: 'qualification',
  SUBJECT_LISTING: 'subject_listing_page',
  PRODUCT_LISTING: 'product_listing_page',
  HIGH_LEVEL_CONTENT: 'standard',
  HIGH_lEVEL_CONTENT_CTA: 'careers',
  404: 'n404',
  FORM: 'form',
  POSTGRADUATE_RESEARCH: 'postgraduate_research',
};

const CODE_NAMES = {
  SHORT_COURSE: 'short_course',
};

const ROUTES = {
  SHORT_COURSES: '/courses/short-courses/',
  SUBJECT_ATOZ: '/courses/atoz/',
  MICROCRENTIALS: '/courses/microcredentials/',
  ACCESS_MODULES: '/courses/modules/',
  CREATIVE_ARTS: '/courses/creative-arts/',
  WIDL_FAQS: '/courses/what-is-distance-learning/faqs/',
  POSTGRADUATE_A2Z_SUBJECTS: '/postgraduate/atoz-subjects/',
};

const PRODUCT_TYPES = {
  MODULE_TYPES: {
    UNDERGRADUATE_MODULE: 'Undergraduate Module',
    POSTGRADUATE_MODULE: 'Postgraduate Module',
    ACCESS_MODULE: 'Access Module',
    SHORT_COURSE_FIXED_PRESENTATION: 'Short course - fixed presentation',
    SHORT_COURSE_CONTINUOUS_PRESENTATION: 'Short course - continuous presentation',
    MICROCREDENTIAL: 'Microcredential',
  },
  QUALIFICATION_TYPES: {
    CERTIFICATE_OF_HIGHER_EDUCATION: 'Certificate of Higher Education',
    DIPLOMA_OF_HIGHER_EDUCATION: 'Diploma of Higher Education',
    HONOURS_DEGREE: 'Honours Degree',
    INTEGRATED_MASTER: 'Integrated Master',
    FOUNDATION_DEGREE: 'Foundation Degree',
    OPEN_UNIVERSITY_CERTIFICATE: 'Open University Certificate',
    HIGHER_TECHNICAL_QUALIFICATIONS: 'Higher Technical Qualifications',
    OU_DIPLOMA: 'Open University Diploma',
    MASTERS_DEGREE: 'Masters Degree',
    POSTGRADUATE_DIPLOMA: 'Postgraduate Diploma',
    POSTGRADUATE_CERTIFICATE: 'Postgraduate Certificate',
    TOP_UP_DEGREE: 'Top up Degree',
    GRADUATE_ENTRY_DEGREE: 'Graduate Entry Degree',
    CREATIVE_ARTS_HONOURS_DEGREE: 'Creative Arts Honours Degree',
    CREATIVE_ARTS_CERTIFICATE_OF_HE: 'Creative Arts Certificate of HE',
    OPEN_UNIVERSITY_DIPLOMA: 'Open University Diploma',
  },
};

const PRODUCT_TYPE_CODENAMES = {
  MODULE_TYPES: {
    UNDERGRADUATE_MODULE: 'undergraduate_module',
    POSTGRADUATE_MODULE: 'postgraduate_module',
    ACCESS_MODULE: 'access_module',
    SHORT_COURSE_FIXED_PRESENTATION: 'short_course___fixed_presentation',
    SHORT_COURSE_CONTINUOUS_PRESENTATION: 'short_course',
    MICROCREDENTIAL: 'microcredential',
  },
};

const OPEN_PRODUCTS = {
  OPEN_DEGREES: 'open-degree',
  OPEN_DIPLOMA: 'open-diploma',
  OPEN_CERTIFICATE: 'open-certificate',
};

const FEES_AND_FUNDING_MODEL = {
  DEFAULT: 'default',
  HIGH_LOW_COST_MODEL_1: 'high_low_cost__model_1',
  HIGH_LOW_COST_MODEL_2: 'high_low_cost__model_2',
  HIGH_LOW_COST_MODEL_3: 'high_low_cost__model_3',
  HIGH_LOW_COST_MODEL_4: 'high_low_cost__model_4',
  HIGH_LOW_COST_MODEL_5: 'high_low_cost__model_5',
  OVERRIDE: 'override',
};

const COUNTRIES = {
  ALL_COUNTRIES: 'all',
  UK: 'uk',
  ENGLAND: 'en',
  NORTHERN_IRELAND: 'ni',
  SCOTLAND: 'sc',
  WALES: 'wa',
  CHANNEL_ISLANDS: '_01',
  ISLE_OF_MAN: '_02',
  IRELAND: 'ie',
  APPROVED_STUDY_AREAS: 'eu',
  REST_OF_WORLD: 'oe',
};

const RENDER_MODES = {
  STANDARD: 'Standard',
  HEROBANNER: 'Hero',
  NONHERO: 'Non-Hero',
};

const FORM_PAGES = {
  EMAIL_US: {
    FORM_ID: '4',
    DEFAULT_TYPE: 'Enquiry',
    SOQ_QUERY_PARAM: 'soq',
    DEFAULT_SOQ_VALUE: '1',
    DEFAULT_QUEUE_NAME: 'Q-SRS-GENERAL',
    FORM_NAME: '9598',
    SOQ_REGEX: /^\d+$/,
  },
  UG_ASK_A_QUESTION: {
    FORM_ID: '20',
    QUESTION_VALUE: 'my question is not listed',
  },
  CALL_ME_BACK: {
    FORM_ID: '5',
    FORM_QUERY_PARAM: 'formID',
    FORM_NAME: '9670',
    FORM_NAME_REGEX: /^\d{4}/,
    DEFAULT_SOQ_VALUE: '4',
    SOQ_QUERY_PARAM: 'soq',
    SOQ_REGEX: /^\d+$/,
    QUEUE_QUERY_PARAM: 'queue',
    DEFAULT_QUEUE_NAME: 'Q-001',
    DEFAULT_QUEUE_REGEX: /^Q-([1-9][0-9]{2}|[0-9][1-9][0-9]|[0-9]{2}[1-9])$/,
  },
  CREATE_ACCOUNT: {
    FORM_ID: '1',
    FORM_NAME: '9671',
    SAVE_FOR_LATER_FORM_NAME: '9772',
    PROSPECT: 'Prospect',
    INFORMAL_PROSPECT: 'Informal Prospect',
    OPEN_LEARN: 'openlearn',
    QUERY_STRING_PPT_SAVE_LATER: 'pptsaveforlater=true',
    QUERY_STRING_ADD_TO_SHORTLIST: 'addtoshortlist=true',
    LIST_TYPE_FORMAL: 'formal',
    LIST_TYPE_IN_FORMAL: 'informal',
  },
  FORM_BUILDER: {
    FORM_BUILDER_SUBMISSION_ID: 'form_builder_submission',
    DEFAULT_TYPE: 'Enquiry',
    DEFAULT_SOQ_VALUE: '1',
    DEFAULT_QUEUE_NAME: 'Q-SRS-GENERAL',
    DEFAULT_PROPOSITION_TYPE_SIGNUP: 'BizForm',
    DEFAULT_TYPE_INTERACTION: 'Interaction',
  },
  QUAL_REG_ROW: {
    FORM_ID: '15',
  },
};

const COUNTRY_CODES = {
  ENGLAND: 'EN|GB',
  NORTHERN_IRELAND: 'NI|GB',
  SCOTLAND: 'SC|GB',
  WALES: 'WA|GB',
};

export {
  SITE_ANCHOR,
  PRODUCT_LIST_ANCHOR,
  LEFT_COLUMN_WIDTH,
  CODE_NAMES,
  ROUTES,
  PAGE_TYPES,
  PRODUCT_TYPES,
  PRODUCT_TYPE_CODENAMES,
  OPEN_PRODUCTS,
  FEES_AND_FUNDING_MODEL,
  COUNTRIES,
  RENDER_MODES,
  FORM_PAGES,
  COUNTRY_CODES,
};
